/* MJ 0928 (MJ-AI): MJ's header is custom — sections/header.liquid (the only place that loads details-disclosure.js) is not on the page — so
   `extends DetailsDisclosure` threw "DetailsDisclosure is not defined" on every product page and the share button never started.
   Use the theme's class when it is loaded, otherwise the same small base class inline (focus-out close, toggle animations, close()). */
var MJShareBase = (typeof DetailsDisclosure !== 'undefined') ? DetailsDisclosure : class extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle ? this.mainDetailsToggle.querySelector('summary').nextElementSibling : null;
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    }
  }
  onFocusOut() { setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }); }
  onToggle() {
    if (!this.content || !this.content.getAnimations) return;
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) this.animations.forEach(a => a.play()); else this.animations.forEach(a => a.cancel());
  }
  close() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    const s = this.mainDetailsToggle.querySelector('summary'); if (s) s.setAttribute('aria-expanded', false);
  }
};
if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends MJShareBase {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        closeButton: this.querySelector('.share-button__close'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share) {
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
      } else {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
      }
    }

    toggleDetails() {
      if (!this.mainDetailsToggle.open) {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.closeButton.classList.add('hidden');
        this.elements.shareSummary.focus();
      }
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.elements.closeButton.classList.remove('hidden');
        this.elements.closeButton.focus();
      });
    }

    updateUrl(url) {
      this.urlToShare = url;
      this.elements.urlInput.value = url;
    }
  });
}
